<!-- <form #f="ngForm" (ngSubmit)="onSubmit(f)"> -->
<p-overlayPanel #fieldInfo [appendTo]="'body'" [dismissable]="true" styleClass="w-75" [showCloseIcon]="true">
  <div class="col-12">
    <div>JsonField: {{ jsonField }}</div>
    <div>Description: {{ getDescription() }}</div>
    <div>Etiqueta Ayuda: FLD_{{ fieldConfig.formId }}&{{ jsonField }}</div>
    <div>Tipo: {{ type }}</div>
    <div>Value: {{ getObjectStr(getValue()) }}</div>
    <div>getNestedProperty: {{ getObjectStr(getNestedProperty(this.model, this.jsonField)) }}</div>
    <div>Model: {{ getObjectStr(model) }}</div>
    <div>Tooltip: {{ tooltipText }}</div>
    <div>FieldStyle: {{ fieldStyle }}</div>
    <div>Editable: {{ editable }}</div>
    <div>IdBuscador: {{ idBuscador }}</div>
    <div>Visibility: {{ visibility }}</div> abstractControl.invalid {{ abstractControl?.invalid }} <br />
    abstractControl.dirty {{ abstractControl?.dirty }} <br /> abstractControl.touched {{ abstractControl?.touched }}
    <br />abstractControl.pristine {{ abstractControl?.pristine }} <br />formGroup.invalid {{ formGroup?.invalid }}
    <br /> formGroup.dirty {{ formGroup?.dirty }} <br /> formGroup.touched {{ formGroup?.touched }}
    <br />formGroup.pristine {{ formGroup?.pristine }}
  </div>
</p-overlayPanel>
<ng-container *ngIf="isVisible()">
  <div class="plycaFormField" [ngClass]="fieldStyle">
    <!-- TITLE -->
    <div *ngIf="type == 'TITLE'" class="titleElement" id="{{ getFormControlName() + '_label' }}"> {{ getDescription() }}
    </div>
    <!-- FIN TITLE -->

    <!-- BREAK-ROW -->
    <div *ngIf="type == 'BREAK-ROW'" class="break-row"></div>
    <!-- FIN BREAK-ROW -->

    <!-- PARAGRAPH -->
    <div *ngIf="type == 'PARAGRAPH'" class="paragraphElement">
      <span [innerHTML]="getDescription()"></span>
    </div>
    <!-- FIN PARAGRAPH -->
    <!-- componentes con un campo de formulario-->
    <ng-container *ngIf="this.abstractControl">
      <!-- TABLE -->
      <div *ngIf="type === 'TABLE'" class="tableElement">
        <!--style="margin: 20px 0"-->
        <ng-container *ngTemplateOutlet="formDescription"></ng-container>
        <formControlError [object]="this.abstractControl"></formControlError>
        <p-table id="{{ getFormControlName() }}" [value]="getNestedProperty(model, jsonField)"
          [rows]="this.fieldConfig.pageSize" [paginator]="showPerPage()" [pageLinks]="4"
          [rowsPerPageOptions]="[5, 10, 25, 50]" class="footer-over-pagination"
          tabindex="{{ isEditable()?tabindex:'-1' }}" [sortField]="this.fieldConfig.order" [scrollable]="false"
          responsiveLayout="scroll">
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="2 + tableColumns.length"> {{ 'Forms.noData' | translate }} </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <!-- cabecera columna de validacion -->
              <th class="plyca-validation-col"></th>
              <!-- cabecera resto de columnas -->
              <th *ngFor="let col of tableColumns"
                [pSortableColumn]="(this.fieldConfig.noSortable) ? undefined :  col.sortFilterTable"
                [style]="col.columnStyle" class="{{ col.type }}TH th-wrap " [field]="col.sortFilterTable"
                [hidden]="!isColVisible(col)" [style]="col.columnStyle"
                pTooltip="{{formService.getDescriptionCol(this, col)}}" tooltipPosition="top" tabindex="-1">
                {{formService.getDescriptionCol(this, col)}} <p-sortIcon
                  [field]="col.sortFilterTable ? col.sortFilterTable : ''" *ngIf="!this.fieldConfig.noSortable"
                  tabindex="-1"></p-sortIcon>
              </th>
              <!-- cabecera columna de botones-->
              <th
                *ngIf="this.fieldConfig.showActionsOnReadOnly==true||isEditable()||fieldConfig.editorConfig&&!isEditable()"
                [style]="getRowButtonStyle()" class="action-column-4buttons"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-col="columns" let-row let-idx="rowIndex">
            <tr>
              <!--  Columna de validacion -->
              <td class="plyca-validation-col">
                <ng-container *ngIf="row?.errors">
                  <a (click)="errPanel.toggle($event)" (mouseover)="errPanel.show($event)"
                    (mouseout)="errPanel.hide($event)" class="p-inputtext error-col  ng-invalid">
                    <!-- <formatDataValue [type]="'TEXT'" [value]="'&nbsp;'" [valueClassObject]="hasRowErrors(row)"></formatDataValue> -->
                    &nbsp; </a>
                  <p-overlayPanel #errPanel [dismissable]="true" [appendTo]="'formElementLabel'">
                    <formControlError [object]="row"></formControlError>
                  </p-overlayPanel>
                </ng-container>
              </td>
              <!-- resto de columnas -->
              <td *ngFor="let col of tableColumns"
                class="{{ fieldConfig.editorConfig ? undefined : 'editable' }} {{ col.type }}"
                [style]="(col)?col.columnStyle:undefined" [hidden]="!isColVisible(col)">
                <!-- Template si es no editable -->
                <ng-container *ngIf="!isEditableRow(row)
                      || (fieldConfig.editorConfig && !isColEditableInline(col))
                      || (col.editable !== undefined && !col.editable);
                      else editableRowTemplate">
                  <ng-container *ngIf="
                              col.type != 'CHECK' &&
                              col.type != 'DROPDOWN' &&
                              col.type != 'MULTISELECT'
                            ">
                    <formatDataValue [type]="col.type" [value]="this.getValueTableColumn(row, col)"
                      [maxDecimals]="col.maxDecimals?col.maxDecimals:2">
                    </formatDataValue>
                  </ng-container>
                  <ng-container *ngIf="col.type == 'CHECK'">
                    <p-checkbox disabled="true" [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'"
                      [ngModel]="this.getCheckNestedProperty(row, col.jsonField)" class="plForm-element {{type}}"
                      binary="true" [readonly]="!isEditable()">
                    </p-checkbox>
                  </ng-container>
                  <ng-container *ngIf="col.type == 'DROPDOWN'">
                    <p-dropdown [readonly]="!isEditable()" [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'"
                      [dataKey]="dropDownDataKey" [ngModel]="this.getNestedProperty(row, col.jsonField)"
                      [options]="col.data" [style]="{ width: '100%' }" [autoWidth]="false"
                      class="plForm-element {{type}}" [dropdownIcon]="'pi'" [group]="isGroupingDropDown()"
                      placeholder="{{ 'General.empty' | translate }}" [showClear]="isEditable()"
                      [disabled]="!isEditable()" emptyMessage="{{ dropDownLoadingMsg() }}"
                      (onFocus)="initLacyDropdown();">
                      <ng-template pTemplate="item" let-item> {{item.label | translate}} </ng-template>
                      <ng-template pTemplate="selectedItem" let-item> {{item.label | translate}} </ng-template>
                    </p-dropdown>
                  </ng-container>
                  <ng-container *ngIf="col.type == 'MULTISELECT'">
                    <p-multiSelect [disabled]="true" [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'"
                      [dataKey]="dropDownDataKey" [ngModel]="this.getNestedProperty(row, col.jsonField)"
                      [options]="col.data" [style]="{ width: '100%' }" [autoWidth]="false" [dropdownIcon]="'pi'"
                      [defaultLabel]="this.getMultiSelectLabel()">
                      <ng-template let-item let-i="index" pTemplate="item"> {{ item?.value ? toString(item?.value) :
                        toString(item) }} </ng-template>
                    </p-multiSelect>
                  </ng-container>
                </ng-container>
                <!-- Template si es editable-->
                <ng-template #editableRowTemplate>
                  <formElement [formGroup]="abstractControl" [fieldConfig]="col" [inlineComponent]="'true'"
                    [index]="idx" [model]="row" [functions]="this.functions"
                    [changeDectectionTimestamp]="changeDectectionTimestamp" (updateGroup)="updateGroupView()"
                    [readonlyElement]="!isEditable()">
                  </formElement>
                </ng-template>
              </td>
              <!-- columna de botones-->
              <td *ngIf="this.fieldConfig.showActionsOnReadOnly==true||isEditable()" [style]="getRowButtonStyle()"
                class="action-column-4buttons">
                <div class="btn-group">
                  <!-- Solo para cuando se muestran las acciones en modo readonly -->
                  <button appNoDblClick
                    *ngIf="this.fieldConfig.showActionsOnReadOnly==true&&fieldConfig.editorConfig&&!isEditable()"
                    class="btn  btn-primary btn-sm t-action-button" (click)="viewRow(row)" tabindex="{{ tabindex }}"
                    title="{{ 'General.view' | translate}}" type="button">
                    <i class="fas fa-eye" aria-hidden="true"></i>
                  </button>
                  <ng-container *ngIf="rowActions && rowActions.length > 0">
                    <ng-container *ngIf="!this.fieldConfig.showGroupedActions">
                      <ng-container *ngFor="let action of rowActions">
                        <button appNoDblClick
                          *ngIf="(action.showOnReadOnly==true && !isEditable())|| (isEditable() && isVisibleRowAction(action,row))"
                          class="btn  btn-primary btn-sm t-action-button" (click)="executeRowAction(action,row)"
                          [attr.disabled]="(isActiveRowAction(action,row )) ? null: 'disabled'"
                          tabindex="{{ tabindex }}" title="{{ action.buttonTextKey | translate}}" type="button">
                          <i [ngClass]="action.imageClass" aria-hidden="true"></i>
                        </button>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="this.fieldConfig.showGroupedActions">
                      <button appNoDblClick class="btn btn-outline-secondary btn-xs" (click)="menu.toggle($event)">
                        <i class="fa fa-cog dropdown-toggle" aria-hidden="true"></i>
                      </button>
                      <p-menu #menu [model]="getMenuItems(row)" [popup]="true" appendTo="body"></p-menu>
                    </ng-container>
                  </ng-container>
                  <button appNoDblClick *ngIf="isEditable()&& fieldConfig.editorConfig"
                    class="btn  btn-primary btn-sm t-action-button" (click)="editRow(row)"
                    [attr.disabled]="(!isEditable() || !isEditableRow(row)) ? 'disabled' : null"
                    tabindex="{{ tabindex }}" title="{{ 'General.edit' | translate}}" type="button">
                    <i class="fas fa-pencil-alt" aria-hidden="true"></i>
                  </button>
                  <button appNoDblClick class="btn btn-outline-secondary btn-sm t-action-button"
                    *ngIf="isEditable() && isRemovableRow(row)"
                    [attr.disabled]="(isEditable() && isEditableRow(row)) ?  null:  'disabled'"
                    (click)="removeRow(idx, row)" tabindex="-1" title="{{ 'General.delete' | translate}}" type="button">
                    <i class="fas fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
              <!-- viewRow cuando la tabla está en modo no editable o readonly sin acciones de fila -->
              <td *ngIf="!this.fieldConfig.showActionsOnReadOnly==true&&fieldConfig.editorConfig&&!isEditable()"
                [style]="getRowButtonStyle()" class="action-column-2">
                <div class="btn-group">
                  <button appNoDblClick *ngIf="fieldConfig.editorConfig" class="btn  btn-primary btn-sm t-action-button"
                    (click)="viewRow(row)" tabindex="{{ tabindex }}" title="{{ 'General.view' | translate}}"
                    type="button">
                    <i class="fas fa-eye" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <div class="float-right btn-group" role="group">
          <ng-container *ngIf="excelLoadEnabled">
            <input type="file" (change)="onFileChange($event)" hidden multiple="false" #fileImportExcel />
            <!-- EXPORT -->
            <button appNoDblClick type="button" class="btn btn-outline-secondary btn-sm add-button "
              [attr.disabled]="!isEditable() ? 'disabled' : null" (click)="export()"
              title="{{ 'General.download' | translate}} {{ getDescription() }}" tabindex="{{ tabindex }}"
              type="button">
              <i class="p-button-icon-left ui-clickable fas fa-download" aria-hidden="true"></i><span
                class="p-button-text ui-clickable"></span>
            </button>
            <!-- IMPORT -->
            <button appNoDblClick type="button" class="btn btn-outline-secondary btn-sm add-button"
              [attr.disabled]="!isEditable() ? 'disabled' : null" (click)="openFileImportDialog()"
              title="{{ 'General.upload' | translate}} {{ getDescription() }}" tabindex="{{ tabindex }}" type="button">
              <i class="p-button-icon-left ui-clickable fas fa-upload" aria-hidden="true"></i><span
                class="p-button-text ui-clickable"></span>
            </button>
            <!-- CLEAR -->
            <button appNoDblClick type="button" class="btn btn-outline-secondary btn-sm add-button"
              [attr.disabled]="!isEditable() ? 'disabled' : null" (click)="clear()"
              title="{{ 'General.clean' | translate}} {{ getDescription() }}" tabindex="{{ tabindex }}" type="button">
              <i class="p-button-icon-left ui-clickable far fa-trash-alt" aria-hidden="true"></i><span
                class="p-button-text ui-clickable"></span>
            </button>
          </ng-container>
          <ng-container *ngTemplateOutlet="fieldActionsTpl"></ng-container>
          <button appNoDblClick class="btn btn-outline-secondary btn-sm add-button"
            [attr.disabled]="!isEditable() ? 'disabled' : null" (click)="openSearchGeneric()"
            title="{{ 'General.search.text' | translate}}" [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'"
            tabindex="{{ tabindex }}" type="button" *ngIf="this.fieldConfig.searchAddEnable===true">
            <i class="p-button-icon-left ui-clickable fas fa-search" aria-hidden="true"></i><span
              class="p-button-text ui-clickable">{{ 'General.search.text' | translate}} {{ getDescription() }}</span>
          </button>
          <button appNoDblClick type="button" class="btn btn-outline-secondary btn-sm add-button ml-2"
            *ngIf="isAddEnabled ()" [attr.disabled]="!isEditable() ? 'disabled' : null" (click)="addRow()"
            title="{{ 'General.add' | translate}} {{ getDescription() }}" tabindex="{{ tabindex }}" type="button">
            <i class="p-button-icon-left ui-clickable fas fa-plus" aria-hidden="true"></i><span
              class="p-button-text ui-clickable">{{ 'General.add' | translate}} {{ getDescription() }}</span>
          </button>
        </div>
      </div>
      <!-- FIN TABLE -->
      <!-- MODO EDICION ¿utilizar float para que funcionen las columnas-->
      <ng-container *ngIf="type !== 'TABLE' && type !== 'TITLE' && type !== 'PARAGRAPH' && type !== 'BREAK-ROW'"
        [formGroup]="this.formGroup">
        <span #formElementLabel aria-hidden="true"></span>
        <ng-container *ngIf="type !== 'CHECK'">
          <!-- && type !== 'TEMPLATE' -->
          <!--&& (visibility === undefined || visibility )-->
          <ng-container *ngTemplateOutlet="formDescription"></ng-container>
        </ng-container>
        <ng-container *ngIf="type == 'LABEL'">
          <formatDataValue [type]="'TEXT'" [value]="getValue()"></formatDataValue>
        </ng-container>
        <!-- ZONA ESPECIFICA POR TIPO DE COMPONENTE -->
        <!-- <div class=""> -->
        <ng-container *ngIf="type == 'STRING' || type == 'TEXT'">
          <div class="p-inputgroup" id="{{ getFormControlName() }}ui">
            <input (focus)="showContextHelp()" (focusout)="setNestedPropertyLostFocus(model, jsonField)"
              *ngIf="!standaloneControl" id="{{ getFormControlName() }}" [formControlName]="getFormControlName()"
              [attr.type]="this.fieldConfig.typePassword?'password':'text'" name="{{ jsonField }}" placeholder=""
              [ngModel]="getValue()" (input)="setNestedProperty(model, jsonField, $event.target.value)" pInputText
              class="plForm-element {{type}}" maxlength="{{ maxlength }}"
              [attr.disabled]="!isEditable() ? 'disabled' : null" [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'"
              autocomplete="new-password" [attr.autofocus]="autofocus ? '' : null"
              [ngStyle]="{'max-width': screenWidth > 768  && widthSize ? widthSize + 'rem': ''}" />

            <!-- appResponsiveScreen [widthSize]="widthSize" -->
            <input (focus)="showContextHelp()" (focusout)="setNestedPropertyLostFocus(model, jsonField)"
              *ngIf="standaloneControl" id="{{ getFormControlName() }}" name="{{ jsonField }}"
              [attr.type]="this.fieldConfig.typePassword?'password':'text'" placeholder="" [ngModel]="getValue()"
              (input)="setNestedProperty(model, jsonField, $event.target.value)" pInputText
              class="plForm-element {{type}}" maxlength="{{ maxlength }}" [ngModelOptions]="{ standalone: true }"
              [attr.disabled]="!isEditable() ? 'disabled' : null" [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'"
              autocomplete="new-password" [attr.autofocus]="autofocus ? '' : null"
              [ngStyle]="{'max-width': screenWidth > 768  && widthSize ? widthSize + 'rem': ''}" />
            <!-- appResponsiveScreen [widthSize]="widthSize" -->
            <ng-container *ngIf="fieldConfig.longText">
              <button appNoDblClick *ngIf="isEditable()" class="btn  btn btn-outline-secondary integrado" type="button"
                (click)="editText(getFormControlName(), getDescription())" title="{{ 'General.edit' | translate}}"
                type="button">
                <i class="fas fa-pen" aria-hidden="true"></i>
              </button>
              <button appNoDblClick *ngIf="!isEditable()" class="btn  btn btn-outline-secondary integrado" type="button"
                (click)="viewText(getFormControlName(), getDescription())" title="{{ 'General.visualize' | translate}}"
                title="{{ 'General.visualize' | translate}}" type="button">
                <i class="fa fa-eye" aria-hidden="true"></i>
              </button>
            </ng-container>
            <ng-container *ngTemplateOutlet="inputActions"></ng-container>
          </div>
          <!-- ZONA PARA GESTION DE BOTONES Y DIALOG DE EDICION / VISUALIZACION DE TEXTOS LARGOS -->
          <!-- BOTONES PARA APERTURA DE DIALOG PARA EDICION / VISUALIZACION DE TEXTOS LARGOS -->
          <!--ng-container *ngIf="fieldConfig.longText">

                    <p-dialog header="{{ getDescription() }}" [(visible)]="editingText" [style]="{width: '50vh'}"
                      [resizable]="false" [dismissableMask]="true" [modal]="true">
                      <div class="container-fluid p-md">
                        <div class="row">
                          <div class="col-12">
                            <textarea pInputTextarea id="{{ getFormControlName() + '_TXTAREA'}} "
                              name="{{ jsonField  + '_TXTAREA'}}" type="text" [(ngModel)]="editTextArea" rows="10"
                              class="plForm-element {{type}}" [ngModelOptions]="{ standalone: true }" maxlength="{{ maxlength }}"
                              [attr.disabled]="!isEditable() ? 'disabled' : null" pInputTextarea
                              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'"></textarea>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <button class="btn btn-primary btn-sm float-left" (click)="stopEditText ()"
                              [attr.disabled]="!isEditable() ? 'disabled' : null">
                              <i class="fas fa-pencil-alt" aria-hidden="true"></i> <span class="d-none d-sm-inline">
                                {{ 'General.accept' | translate }}</span>
                            </button>
                            <button class="btn btn-secondary btn-sm float-right" (click)="cancelEditText()">
                              <i class="fa fa-cancel" aria-hidden="true"></i> <span class="d-none d-sm-inline">
                                {{ 'General.cancel' | translate }}</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </p-dialog>

                  </ng-container-->
        </ng-container>
        <ng-container class="form-elements__textarea" *ngIf="type === formElementsTypes.TEXTAREA">
          <div class="form-elements__textarea--container">
            <div
              [ngClass]="{
              'form-elements__textarea--button-container':  type === formElementsTypes.TEXTAREA,
              'form-elements__textarea--button-container-help': type === formElementsTypes.TEXTAREA && helpEntriesAvailable()}">
              <button appNoDblClick class="btn btn-outline-secondary" [ngClass]="{
                'form-elements__textarea--button-container-button-max-height': (styleClass && !rowsAllow) || (styleClass && rowsAllow),
                'form-elements__textarea--button-container-button-auto': (!styleClass && rowsAllow) || (!styleClass && !rowsAllow)
                }" type="button" (click)="editText(getFormControlName(), getDescription(), !isEditable())"
                title="{{ 'General.edit' | translate}}">
                <i *ngIf="isEditable()" class="fas fa-pen" aria-hidden="true"></i>
                <i *ngIf="!isEditable()" class="fa fa-eye" aria-hidden="true"></i>
              </button>
              <textarea (focus)="showContextHelp()" *ngIf="!standaloneControl" id="{{ getFormControlName() }}"
                [formControlName]="getFormControlName()" name="{{ jsonField }}" type="text"
                [ngModel]="getNestedProperty(model, jsonField)"
                (input)="setNestedProperty(model, jsonField, $event.target.value)" rows="{{rowsAllow}}"
                [ngClass]="styleClass" class="form-elements__textarea plForm-element {{type}}"
                [attr.maxLength]="maxlength" [attr.disabled]="!isEditable() ? 'disabled' : null"
                pInputTextarea></textarea>
              <textarea (focus)="showContextHelp()" *ngIf="standaloneControl" id="{{ getFormControlName() }}"
                name="{{ jsonField }}" type="text" [ngModel]="getNestedProperty(model, jsonField)"
                (input)="setNestedProperty(model, jsonField, $event.target.value)" rows="{{rowsAllow}}"
                class="form-elements__textarea plForm-element {{type}}" [ngModelOptions]="{ standalone: true }"
                [attr.maxLength]="maxlength" [attr.disabled]="!isEditable() ? 'disabled' : null" pInputTextarea
                [ngClass]="isEditable() ? 'EDITABLE'+styleClass : 'NOEDITABLE'+styleClass"></textarea>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="type == 'CHECK'" class="p-inputgroup">
          <!-- <input id="{{getFormControlName()}}" name="{{jsonField}}" type="checkbox" value="checked" [value]="getNestedProperty(model, jsonField)"
                          (input)="setNestedProperty(model, jsonField, $event.target.value)" /> -->
          <p-checkbox inputId="{{getFormControlName()}}" (focus)="showContextHelp()"
            [ngModel]="getCheckNestedProperty(model, jsonField)" [formControlName]="getFormControlName()"
            (ngModelChange)="setCheckValue( $event)" binary="true" [disabled]="!isEditable()"
            [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" name="{{getFormControlName()}}">
          </p-checkbox>
          <ng-container *ngTemplateOutlet="formDescription"></ng-container>
        </ng-container>
        <ng-container *ngIf="type == 'SELECTBUTTON'" class="p-inputgroup">
          <p-selectButton inputId="{{getFormControlName()}}" (focus)="showContextHelp()"
            [ngModel]="getNestedProperty(model, jsonField)" [formControlName]="getFormControlName()"
            [options]="getOptions()" (ngModelChange)="setCheckValue( $event)" optionLabel="label" optionValue="value"
            [disabled]="!isEditable()" [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'"
            name="{{getFormControlName()}}">
          </p-selectButton>
        </ng-container>
        <div class="fieldMW" *ngIf="type == 'DATE' || type == 'DATETIME'">
          <p-calendar [appendTo]="'body'" [showOnFocus]="false" (focus)="showContextHelp()" *ngIf="!standaloneControl"
            inputId="{{ getFormControlName() }}" name="{{ jsonField }}" [formControlName]="getFormControlName()"
            [ngModel]="getNestedProperty(model, jsonField)" (onSelect)="setDateValue(model, jsonField, $event)"
            (onClearClick)="setDateValue(model, jsonField, undefined)"
            (onBlur)="setDateValue(model, jsonField, $event.target.value)" class="plForm-element {{type}}"
            [dateFormat]="PRIMENG_DATE_FORMAT" showButtonBar="true" showIcon="true" [showTime]="type === 'DATETIME'"
            [disabled]="!isEditable() ? 'disabled' : null"
            [ngClass]="isEditable() ? 'EDITABLE ' : 'ui-state-disabled:disabled'"
            [touchUI]="deviceDetector.isMobile() || deviceDetector.isTablet()" [firstDayOfWeek]=1>
          </p-calendar>
          <p-calendar [appendTo]="'body'" [showOnFocus]="false" (focus)="showContextHelp()" *ngIf="standaloneControl"
            inputId="{{ getFormControlName() }}" name="{{ jsonField }}" [ngModel]="getNestedProperty(model, jsonField)"
            (onSelect)="setDateValue(model, jsonField, $event)"
            (onClearClick)="setDateValue(model, jsonField, undefined)"
            (onBlur)="setDateValue(model, jsonField, $event.target.value)" class="plForm-element {{type}}"
            [dateFormat]="PRIMENG_DATE_FORMAT" showButtonBar="true" showIcon="true" [showTime]="type === 'DATETIME'"
            [ngModelOptions]="{ standalone: true }" [disabled]="!isEditable() ? 'disabled' : null"
            [ngClass]="isEditable() ? 'EDITABLE' : 'ui-state-disabled:disabled'"
            [touchUI]="deviceDetector.isMobile() || deviceDetector.isTablet()" [firstDayOfWeek]=1></p-calendar>
          <span class="small float-right" *ngIf="type == 'DATETIME'">Zona Horaria: {{today() | date:'zzz'}}</span>
        </div>
        <ng-container *ngIf="type == 'MASK'">
          <div class="fieldMW p-inputgroup">
            <p-inputMask (focus)="showContextHelp()" (focusout)="setNestedPropertyLostFocus(model, jsonField)"
              *ngIf="!standaloneControl" inputId="{{ getFormControlName() }}" name="{{ jsonField }}"
              [formControlName]="getFormControlName()" [ngModel]="getNestedProperty(model, jsonField)"
              (onBlur)="setNestedProperty(model, jsonField, $event.target.value)" [mask]="pattern" [placeholder]=""
              maxlength="{{ maxlength }}" class="plForm-element {{type}}" [disabled]="!isEditable() ? 'disabled' : null"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" class="plForm-element  {{type}}"></p-inputMask>
            <p-inputMask (focus)="showContextHelp()" (focusout)="setNestedPropertyLostFocus(model, jsonField)"
              *ngIf="standaloneControl" inputId="{{ getFormControlName() }}" name="{{ jsonField }}"
              [ngModel]="getNestedProperty(model, jsonField)"
              (onBlur)="setNestedProperty(model, jsonField, $event.target.value)" [mask]="pattern" [placeholder]=""
              class="plForm-element {{type}}" maxlength="{{ maxlength }}" [ngModelOptions]="{ standalone: true }"
              [disabled]="!isEditable() ? 'disabled' : null" [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'"
              class="plForm-element  {{type}}">
            </p-inputMask>
            <ng-container *ngTemplateOutlet="inputActions"></ng-container>
          </div>
        </ng-container>
        <!-- locale="de-DE" para que los importes muestren correctamente el punto en los miles
            Revisar la url de inputnumber de ejemplo PLP.EXP-10031 -->
        <div class="fieldMW p-inputgroup" *ngIf="type == 'CURRENCY'">
          <p-inputNumber #elementCURRENCY *ngIf="!standaloneControl" mode="currency" currency="EUR" locale="de-DE"
            [minFractionDigits]="this.fieldConfig.maxDecimals" [maxFractionDigits]="this.fieldConfig.maxDecimals"
            [ngModel]="this.getValue()" (onBlur)="setNumberFormat($event,elementCURRENCY)" (focus)="showContextHelp()"
            id="{{ getFormControlName() }}" [formControlName]="getFormControlName()" name="{{ jsonField }}" type="text"
            placeholder="" class="plForm-element {{type}}" [disabled]="!isEditable()"
            [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" maxlength="{{ maxlength }}"
            autocomplete="new-password">
          </p-inputNumber>
          <p-inputNumber #elementCURRENCY *ngIf="standaloneControl" mode="currency" currency="EUR" locale="de-DE"
            [minFractionDigits]="this.fieldConfig.maxDecimals" [maxFractionDigits]="this.fieldConfig.maxDecimals"
            [ngModel]="this.getValue()" (onBlur)="setNumberFormat($event,elementCURRENCY)" (focus)="showContextHelp()"
            id="{{ getFormControlName() }}" name="{{ jsonField }}" type="text" placeholder=""
            class="plForm-element {{type}}" [ngModelOptions]="{ standalone: true }" [disabled]="!isEditable()"
            [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" maxlength="{{ maxlength }}"
            autocomplete="new-password">
          </p-inputNumber>
        </div>
        <div class="fieldMW p-inputgroup" *ngIf=" type == 'PERCENTAGE'">
          <p-inputNumber #elementPERCENTAGE *ngIf="!standaloneControl" mode="decimal" suffix="%" locale="de-DE"
            [minFractionDigits]="this.fieldConfig.maxDecimals" [maxFractionDigits]="this.fieldConfig.maxDecimals"
            [ngModel]="this.getValue()" (onBlur)="setNumberFormat($event,elementPERCENTAGE)" (focus)="showContextHelp()"
            id="{{ getFormControlName() }}" [formControlName]="getFormControlName()" name="{{ jsonField }}" type="text"
            placeholder="" class="plForm-element {{type}}" [disabled]="!isEditable()"
            [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" maxlength="{{ maxlength }}"
            autocomplete="new-password">
          </p-inputNumber>
          <p-inputNumber #elementPERCENTAGE *ngIf="standaloneControl" mode="decimal" suffix="%" locale="de-DE"
            [minFractionDigits]="this.fieldConfig.maxDecimals" [maxFractionDigits]="this.fieldConfig.maxDecimals"
            [ngModel]="this.getValue()" (onBlur)="setNumberFormat($event,elementPERCENTAGE)" (focus)="showContextHelp()"
            id="{{ getFormControlName() }}" name="{{ jsonField }}" type="text" placeholder=""
            class="plForm-element {{type}}" [ngModelOptions]="{ standalone: true }" [disabled]="!isEditable()"
            [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" maxlength="{{ maxlength }}"
            autocomplete="new-password">
          </p-inputNumber>
        </div>
        <div class="fieldMW p-inputgroup" *ngIf=" type == 'DECIMAL'">
          <p-inputNumber #elementDECIMAL [prefix]="this.fieldConfig.prefix" [suffix]="this.fieldConfig.suffix"
            *ngIf="!standaloneControl" mode="decimal" locale="de-DE" [minFractionDigits]="this.fieldConfig.maxDecimals"
            [maxFractionDigits]="this.fieldConfig.maxDecimals" [ngModel]="this.getValue()"
            (onBlur)="setNumberFormat($event, elementDECIMAL)" (focus)="showContextHelp()"
            id="{{ getFormControlName() }}" [formControlName]="getFormControlName()" name="{{ jsonField }}" type="text"
            placeholder="" class="plForm-element {{type}}" [disabled]="!isEditable()"
            [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" maxlength="{{ maxlength }}"
            autocomplete="new-password">
          </p-inputNumber>
          <p-inputNumber #elementDECIMAL *ngIf="standaloneControl" mode="decimal" locale="de-DE"
            [minFractionDigits]="this.fieldConfig.maxDecimals" [maxFractionDigits]="this.fieldConfig.maxDecimals"
            [ngModel]="this.getValue()" (onBlur)="setNumberFormat($event,elementDECIMAL)" (focus)="showContextHelp()"
            id="{{ getFormControlName() }}" name="{{ jsonField }}" type="text" placeholder=""
            class="plForm-element {{type}}" [ngModelOptions]="{ standalone: true }" [disabled]="!isEditable()"
            [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" maxlength="{{ maxlength }}"
            autocomplete="new-password">
          </p-inputNumber>
        </div>
        <div class="fieldMW p-inputgroup" *ngIf="  type == 'INTEGER'">
          <p-inputNumber #elementINTEGER [min]="this.fieldConfig.min" [max]="this.fieldConfig.max"
            [prefix]="this.fieldConfig.prefix" [suffix]="this.fieldConfig.suffix" *ngIf="!standaloneControl"
            locale="de-DE" [maxFractionDigits]="0" [ngModel]="this.getValue()"
            (onBlur)="setNumberFormat($event,elementINTEGER)" (focus)="showContextHelp()"
            id="{{ getFormControlName() }}" [formControlName]="getFormControlName()" name="{{ jsonField }}" type="text"
            [placeholder]="this.fieldConfig.placeholder" class="plForm-element {{type}}" [disabled]="!isEditable()"
            [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" maxlength="{{ maxlength }}"
            autocomplete="new-password">
          </p-inputNumber>
          <p-inputNumber #elementINTEGER [min]="this.fieldConfig.min" [max]="this.fieldConfig.max"
            *ngIf=" standaloneControl" locale="de-DE" [maxFractionDigits]="0" [ngModel]="this.getValue()"
            (onBlur)="setNumberFormat($event,elementINTEGER)" (focus)="showContextHelp()"
            id="{{ getFormControlName() }}" name="{{ jsonField }}" type="text" placeholder=""
            class="plForm-element {{type}}" [ngModelOptions]="{ standalone: true }" [disabled]="!isEditable()"
            [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" maxlength="{{ maxlength }}"
            autocomplete="new-password">
          </p-inputNumber>
        </div>
        <ng-container *ngIf="type == 'DROPDOWN'">
          <div [ngStyle]="{'max-width': screenWidth > 768  && widthSize ? widthSize + 'rem': ''}">
            <p-dropdown (focus)="showContextHelp()" *ngIf="!standaloneControl" inputId="{{ getFormControlName() }}"
              name="{{ jsonField }}" [formControlName]="getFormControlName()" [ngModel]="getValue()"
              (onChange)="setNestedProperty(model, jsonField, $event.value)" [dataKey]="dropDownDataKey"
              [options]="getOptions()" [style]="{ width: '100%' }" [autoWidth]="false" class="plForm-element fieldMW"
              [readonly]="!isEditable()" [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'"
              [group]="isGroupingDropDown()" placeholder="{{ 'General.empty' | translate }}"
              [showClear]="isEditable() && showClearOption()" (onShow)="getOptions();" [disabled]="!isEditable()"
              [editable]="this.fieldConfig.editableText" emptyMessage="{{ dropDownLoadingMsg() }}"
              (onFocus)="initLacyDropdown();" [appendTo]="'body'">
              <ng-template pTemplate="item" let-item> {{item.label | translate}} </ng-template>
              <ng-template pTemplate="selectedItem" let-item> {{item.label | translate}} </ng-template>
            </p-dropdown>
            <p-dropdown (focus)="showContextHelp();" *ngIf="standaloneControl" inputId="{{ getFormControlName() }}"
              name="{{ jsonField }}" [ngModel]="getValue()"
              (onChange)="setNestedProperty(model, jsonField, $event.value)" [dataKey]="dropDownDataKey"
              [options]="getOptions()" [style]="{ width: '100%' }" [autoWidth]="false" class="plForm-element fieldMW"
              [ngModelOptions]="{ standalone: true }" [readonly]="!isEditable()" (onShow)="getOptions();"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" [group]="isGroupingDropDown()"
              placeholder="{{ 'General.empty' | translate }}" [showClear]="isEditable() && showClearOption()"
              [disabled]="!isEditable()" [editable]="this.fieldConfig.editableText">
              <ng-template pTemplate="item" let-item> {{item.label | translate}} </ng-template>
              <ng-template pTemplate="selectedItem" let-item> {{item.label | translate}} </ng-template>
            </p-dropdown>
          </div>
        </ng-container>
        <ng-container *ngIf="type == 'MULTISELECT'">
          <p-multiSelect (focus)="showContextHelp()" *ngIf="!standaloneControl" [dataKey]="dropDownDataKey"
            [options]="getOptions()" [ngModel]="getNestedProperty(model, jsonField)" [inputId]="getFormControlName()"
            [name]="getFormControlName()" (onChange)="setNestedProperty(model, jsonField, $event.value)"
            [displaySelectedLabel]="true" formControlName="{{ getFormControlName() }}" [disabled]="!isEditable()"
            [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" [defaultLabel]="this.getMultiSelectLabel()"
            [readonly]="!isEditable()" [appendTo]="'body'">
            <ng-template let-item let-i="index" pTemplate="item"> {{ item?.label ? item.label : toString(item) }}
            </ng-template>
          </p-multiSelect>
          <p-multiSelect (focus)="showContextHelp()" *ngIf="standaloneControl" [dataKey]="dropDownDataKey"
            [options]="getOptions()" [ngModel]="getNestedProperty(model, jsonField)" [inputId]="getFormControlName()"
            [name]="getFormControlName()" (onChange)="setNestedProperty(model, jsonField, $event.value)"
            [displaySelectedLabel]="true" [ngModelOptions]="{ standalone: true }" [disabled]="!isEditable()"
            [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" [defaultLabel]="this.getMultiSelectLabel()"
            [readonly]="!isEditable()">
            <ng-template let-item let-i="index" pTemplate="item"> {{ item?.label ? item.label : toString(item) }}
            </ng-template>
          </p-multiSelect>
        </ng-container>
        <!-- YES_NO MODEL -->
        <div class="fieldMW" *ngIf="type == 'YES_NO'">
          <p-dropdown (focus)="showContextHelp()" *ngIf="!standaloneControl" inputId="{{ getFormControlName() }}"
            name="{{ jsonField }}" [formControlName]="getFormControlName()" [ngModel]="getValue()"
            (onChange)="setNestedProperty(model, jsonField, $event.value)" [options]="yesNoModel"
            [style]="{ width: '100%' }" [autoWidth]="false" class="plForm-element {{type}}" [readonly]="!isEditable()"
            [ngClass]="isEditable() ? 'YES_NO EDITABLE' : 'YES_NO NOEDITABLE'"
            placeholder="{{ 'General.empty' | translate }}" [showClear]="isEditable()"
            [disabled]="!isEditable()"></p-dropdown>
          <p-dropdown (focus)="showContextHelp()" *ngIf="standaloneControl" inputId="{{ getFormControlName() }}"
            name="{{ jsonField }}" [ngModel]="getValue()" (onChange)="setNestedProperty(model, jsonField, $event.value)"
            [options]="yesNoModel" [style]="{ width: '100%' }" [autoWidth]="false" class="plForm-element {{type}}"
            [ngModelOptions]="{ standalone: true }" [readonly]="!isEditable()"
            [ngClass]="isEditable() ? 'YES_NO EDITABLE' : 'YES_NO NOEDITABLE'"
            placeholder="{{ 'General.empty' | translate }}" [showClear]="isEditable()"
            [disabled]="!isEditable()"></p-dropdown>
        </div>
        <ng-container *ngIf="type == 'FILE'">
          <upload-files *ngIf="!standaloneControl" [documentClass]="documentClass"
            [allowedFileExtensions]="allowedFileExtensions" [allowMultipleFiles]="!this.fieldConfig.singleFile"
            [files]="getNestedProperty(model, jsonField)" [formControlName]="getFormControlName()"
            (deleteItem)="deleteFileItem($event)" (addItem)="addFileItem($event)" class="plForm-element {{type}}"
            (modifyItem)="modifyFileItem($event)" [readonly]="!isEditable()" ngDefaultControl>
          </upload-files>
          <upload-files *ngIf="standaloneControl" [documentClass]="documentClass"
            [allowedFileExtensions]="allowedFileExtensions" [allowMultipleFiles]="!this.fieldConfig.singleFile"
            [ngModelOptions]="{ standalone: true }" [files]="getNestedProperty(model, jsonField)"
            (deleteItem)="deleteFileItem($event)" (addItem)="addFileItem($event)" class="plForm-element {{type}}"
            (modifyItem)="modifyFileItem($event)" [readonly]="!isEditable()" ngDefaultControl>
          </upload-files>
        </ng-container>
        <ng-container *ngIf="type == 'SEARCH'">
          <p-overlayPanel #multiValueTooltip [dismissable]="true" [appendTo]="'body'"> {{toString(getValue()) ?
            toString(getValue()) : model?.[jsonField] | checkObject}}
          </p-overlayPanel>
          <div class="p-inputgroup formplyca-search " id="{{ getFormControlName() }}ui"
            (mouseover)="(fieldConfig.searchConfig?.multiSelection) ? showMultiValueTooltip($event, multiValueTooltip) : undefined"
            (mouseout)="(fieldConfig.searchConfig?.multiSelection) ? multiValueTooltip.hide() :undefined" #searchDiv
            pTooltip="{{toString(getValue()) ? toString(getValue()) : model?.[jsonField] | checkObject}}"
            tooltipStyleClass="tooltipSEARCH"
            [ngStyle]="{'max-width': screenWidth > 768  && widthSize ? widthSize + 'rem': ''}">
            <input *ngIf="!standaloneControl" id="{{ getFormControlName() }}" [formControlName]="getFormControlName()"
              name="{{ jsonField }}"
              [ngModel]="toString(getValue()) ? toString(getValue()) : model?.[jsonField] | checkObject" disabled="true"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" class="plForm-element {{type}}" type="text"
              pInputText autocomplete="new-password"
              (input)="setNestedProperty(model, jsonField, $event.target.value)" />
            <input *ngIf="standaloneControl" [ngModelOptions]="{ standalone: true }" id="{{ getFormControlName() }}"
              name="{{ jsonField }} "
              [ngModel]="toString(getValue()) ? toString(getValue()) : model?.[jsonField] | checkObject"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" disabled="true" class="plForm-element  {{type}}"
              type="text" pInputText autocomplete="new-password"
              (input)="setNestedProperty(model, jsonField, $event.target.value)" />
            <!-- <div class="input-group-btn "> -->
            <button appNoDblClick id="{{ getFormControlName() }}btn" class="btn btn-outline-secondary integrado"
              type="button" (click)="clearFormControl()" title="{{ 'General.delete' | translate}}"
              [attr.disabled]="!isEditable() ? 'disabled' : null" [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'"
              tabindex="-1" type="button">
              <i class="pi pi-times"></i>
            </button>
            <button appNoDblClick
              *ngIf="(!this.fieldConfig.inputActions || this.fieldConfig.inputActions.length == 0) || this.fieldConfig.actionsAndSearchEnabled  "
              class="btn btn-outline-secondary integrado" type="button" (click)="openSearchGeneric()"
              title="{{ 'General.search.text' | translate}}" [attr.disabled]="!isEditable() ? 'disabled' : null"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" tabindex="{{ tabindex }}" type="button">
              <i class="pi pi-caret-down"></i>
            </button>
            <ng-container *ngTemplateOutlet="inputActions"></ng-container>
            <!-- </div>
                  <button *ngIf="this.fieldConfig.showActions && !standaloneControl" type="button"
                    (click)="openSearchGeneric()" title="{{ 'General.search.text' | translate}}"
                    [attr.disabled]="!isEditable() ? 'disabled' : null" [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'"
                    tabindex="{{ tabindex }}" type="button" class="btn btn-primary search-button"> <i class="fas fa-search"></i>
                    <span class="p-button-text ui-clickable"> {{ getDescription() }}</span></button>
                  <button *ngIf=" this.fieldConfig.showActions && standaloneControl" type="button"
                    (click)="openSearchGeneric()" title="{{ 'General.search.text' | translate}}"
                    [attr.disabled]="!isEditable() ? 'disabled' : null" [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'"
                    tabindex="{{ tabindex }}" type="button" class="btn btn-primary search-button"> <i class="fas fa-search"></i>
                    <span class="p-button-text ui-clickable"> {{ getDescription() }}</span></button>-->
          </div>
        </ng-container>
        <ng-container *ngIf="type == 'UOSEARCH'">
          <div class="p-inputgroup" id="{{ getFormControlName() }}ui">
            <input *ngIf="!standaloneControl" id="{{ getFormControlName() }}" [formControlName]="getFormControlName()"
              name="{{ jsonField }}" [ngModel]="toString(getValue())" disabled="true"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" class="plForm-element {{type}}" pInputText
              autocomplete="new-password" />
            <input *ngIf="standaloneControl" [ngModelOptions]="{ standalone: true }" id="{{ getFormControlName() }}"
              name="{{ jsonField }}" [ngModel]="toString(getValue())" disabled="true"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" class="plForm-element {{type}}" pInputText
              autocomplete="new-password" />
            <!-- <div class="input-group-btn "> -->
            <button appNoDblClick id="{{ getFormControlName() }}btn" class="btn btn-outline-secondary integrado"
              type="button" (click)="clearFormControl()" title="{{ 'General.delete' | translate}}"
              [attr.disabled]="!isEditable() ? 'disabled' : null" [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'"
              tabindex="-1">
              <i class="pi pi-times"></i>
            </button>
            <button appNoDblClick class="btn btn-outline-secondary integrado" type="button"
              title="{{ 'General.search.text' | translate}}" (click)="openUOSearch()"
              [attr.disabled]="!isEditable() ? 'disabled' : null" [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'"
              tabindex="{{ tabindex }}">
              <i class="pi pi-caret-down"></i>
            </button>
            <!-- <button class="btn  btn-primary btn-sm " type="button " (click)="openUOSearch() " style="padding: 4px 8px;margin:0; " [attr.disabled]="!editable ? 'disabled' : null">
                    <i class="pi pi-caret-down "></i>
                  </button>
                  <button class="btn  btn-danger btn-sm " type="button " (click)="clearFormControl() " style="padding: 4px 8px;margin:0;" [attr.disabled]="!editable ? 'disabled' : null">
                    <i class="fa fa-trash-o "></i>
                  </button> -->
            <!-- </div> -->
          </div>
        </ng-container>
        <ng-container *ngIf="type == 'CPVSEARCH'">
          <div class="p-inputgroup">
            <input *ngIf="!standaloneControl" id="{{ getFormControlName() }}" [formControlName]="getFormControlName()"
              name="{{ jsonField }}" [ngModel]="toString(getNestedProperty(model, jsonField))" disabled="true"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" class="plForm-element {{type}}" pInputText
              autocomplete="new-password" />
            <input *ngIf="standaloneControl" [ngModelOptions]="{ standalone: true }" id="{{ getFormControlName() }}"
              name="{{ jsonField }}" [ngModel]="toString(getNestedProperty(model, jsonField))" disabled="true"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" class="plForm-element {{type}}" pInputText
              autocomplete="new-password" />
            <!-- <div class="input-group-btn "> -->
            <button appNoDblClick class="btn btn-outline-secondary integrado" type="button" (click)="clearFormControl()"
              title="{{ 'General.delete' | translate}}" [attr.disabled]="!isEditable() ? 'disabled' : null"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" tabindex="-1">
              <i class="pi pi-times"></i>
            </button>
            <button appNoDblClick class="btn btn-outline-secondary integrado" type="button" (click)="openCPVSearch()"
              title="{{ 'General.search.text' | translate}}" [attr.disabled]="!isEditable() ? 'disabled' : null"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" tabindex="{{ tabindex }}">
              <i class="pi pi-caret-down"></i>
            </button>
            <!-- <button class="btn  btn-primary btn-sm " type="button " (click)="openCPVSearch() " style="padding: 4px 8px;margin:0; " [attr.disabled]="!editable ? 'disabled' : null">
                    <i class="pi pi-caret-down "></i>
                  </button>
                  <button class="btn  btn-danger btn-sm " type="button " (click)="clearFormControl() " style="padding: 4px 8px;margin:0; "
                  [attr.disabled]="!editable ? 'disabled' : null">
                    <i class="fa fa-trash-o "></i>
                  </button> -->
            <!-- </div> -->
          </div>
        </ng-container>
        <ng-container *ngIf="type == 'INFORMESEARCH'">
          <div class="p-inputgroup " [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'">
            <input *ngIf="!standaloneControl" id="{{ getFormControlName() }}" [formControlName]="getFormControlName()"
              name="{{ jsonField }}" [ngModel]="toString(getNestedProperty(model, jsonField))" disabled="true"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" class="plForm-element {{type}}" pInputText
              autocomplete="new-password" />
            <input *ngIf="standaloneControl" [ngModelOptions]="{ standalone: true }" id="{{ getFormControlName() }}"
              name="{{ jsonField }}" [ngModel]="toString(getNestedProperty(model, jsonField))" disabled="true"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" class="plForm-element {{type}}" pInputText
              autocomplete="new-password" />
            <button appNoDblClick class="btn btn-outline-secondary integrado" type="button" (click)="clearFormControl()"
              title="{{ 'General.delete' | translate}}" [attr.disabled]="!isEditable() ? 'disabled' : null"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" tabindex="-1">
              <i class="pi pi-times"></i>
            </button>
            <button appNoDblClick class="btn btn-outline-secondary integrado" type="button" (click)="openReportSearch()"
              title="{{ 'General.search.text' | translate}}" [attr.disabled]="!isEditable() ? 'disabled' : null"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" tabindex="{{ tabindex }}">
              <i class="pi pi-caret-down"></i>
            </button>
          </div>
        </ng-container>
        <ng-container *ngIf="type == 'FORMEDITOR'">
          <div class="p-inputgroup ">
            <input *ngIf="!standaloneControl" id="{{ getFormControlName() }}" [formControlName]="getFormControlName()"
              name="{{ jsonField }}" [ngModel]="toString(getNestedProperty(model, jsonField))" disabled="true"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" class="plForm-element {{type}}" pInputText
              autocomplete="new-password" />
            <input *ngIf="standaloneControl" [ngModelOptions]="{ standalone: true }" id="{{ getFormControlName() }}"
              name="{{ jsonField }}" [ngModel]="toString(getNestedProperty(model, jsonField))" disabled="true"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" class="plForm-element {{type}}" pInputText
              autocomplete="new-password" />
            <!-- <div class="input-group-btn "> -->
            <button appNoDblClick class="btn  btn btn-outline-secondary integrado" type="button"
              (click)="clearFormControl()" title="{{ 'General.delete' | translate}}"
              [attr.disabled]="!isEditable() ? 'disabled' : null" [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'"
              tabindex="-1">
              <i class="fas fa-times "></i>
            </button>
            <button appNoDblClick class="btn  btn btn-outline-secondary integrado" type="button"
              (click)="editRow(getNestedProperty(model, jsonField))" title="{{ 'General.edit' | translate}}"
              [attr.disabled]="!isEditable() ? 'disabled' : null" [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'">
              <i class="pi pi-caret-down"></i>
            </button>
            <!-- </div> -->
          </div>
        </ng-container>
        <!-- HTMLEDITOR
            [modules]="editorModules" , para la ayuda , al incluir imagen aparece un control para modificar su tamaño
            -->
        <ng-container *ngIf="type == 'HTMLEDITOR'">
          <p-editor *ngIf="!standaloneControl" inputId="{{ getFormControlName() }}" name="{{ jsonField }}"
            [formControlName]="getFormControlName()" [ngModel]="getNestedProperty(model, jsonField)"
            (onTextChange)="setNestedProperty(model, jsonField, $event.htmlValue)" class="plForm-element {{type}}"
            [style]="{ height: '320px' }" [readonly]="!isEditable()"
            [ngClass]="(isEditable()) ? 'EDITABLE' : 'NOEDITABLE'" [modules]="editorModules">
            <p-header *ngIf="!isEditable()">
            </p-header>
            <p-header *ngIf="isEditable()">
              <ng-container *ngTemplateOutlet="editorToolbar"></ng-container>
            </p-header>
          </p-editor>
          <p-editor *ngIf="standaloneControl" inputId="{{ getFormControlName() }}" name="{{ jsonField }}"
            [formControlName]="getFormControlName()" [ngModel]="getNestedProperty(model, jsonField)"
            (onTextChange)="setNestedProperty(model, jsonField, $event.htmlValue)" class="plForm-element {{type}}"
            [style]="{ height: '320px' }" [ngModelOptions]="{ standalone: true }" [readonly]="!isEditable()"
            [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" [modules]="editorModules">
            <p-header *ngIf="!isEditable()">
            </p-header>
            <p-header *ngIf="isEditable()">
              <ng-container *ngTemplateOutlet="editorToolbar"></ng-container>
            </p-header>
          </p-editor>
        </ng-container>
        <ng-container *ngIf="type == 'CHIPS'">
          <!-- <p-chips
                    tabindex="{{ tabindex }}"
                    *ngIf="!standaloneControl"
                    inputId="{{ getFormControlName() }}"
                    name="{{ jsonField }}"
                    [formControlName]="getFormControlName()"
                    [ngModel]="getNestedProperty(model, jsonField)"
                    (onChange)="setNestedProperty(model, jsonField, $event.value)"
                    [style]="{ width: '100%' }"
                    [autoWidth]="false"
                    class="plForm-element {{type}}"
                    [readonly]="!isEditable()"
                    [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'"
                    placeholder="{{ 'General.select' | translate }}"
                  >
                  </p-chips> -->
          <div class="p-inputgroup formplyca-chips ">
            <p-chips [ngModelOptions]="
                      standaloneControl ? { standalone: true } : undefined
                    " inputId="{{ getFormControlName() }}" name="{{ jsonField }}"
              [formControlName]="getFormControlName()" [(ngModel)]="model[jsonField]" [style]="{ width: '100%' }"
              [autoWidth]="false" class="plForm-element {{type}}" [readonly]="!isEditable()"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" (onAdd)='onAddChip()' (onRemove)='onRemoveChip()'
              placeholder="{{ 'General.empty' | translate }}">
              <ng-template let-item pTemplate="item"> {{ item?.description?item?.description:item }} </ng-template>
            </p-chips>
            <ng-container *ngTemplateOutlet="inputActions"></ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf="type == 'DIVISION'">
          <div class="p-inputgroup formplyca-division" [ngClass]=" isEditable() ? 'EDITABLE' : 'NOEDITABLE'"
            id=" {{ getFormControlName() }}ui">
            <input *ngIf="!standaloneControl" id="{{ getFormControlName() }}" [formControlName]="getFormControlName()"
              name="{{ jsonField }}" [ngModel]="toString(getNestedProperty(model, jsonField))" disabled="disabled"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" class="plForm-element {{type}}" type="text"
              pInputText autocomplete="new-password" />
            <input *ngIf="standaloneControl" [ngModelOptions]="{ standalone: true }" id="{{ getFormControlName() }}"
              name="{{ jsonField }} " [ngModel]="toString(getNestedProperty(model, jsonField))"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" disabled="disabled" class="plForm-element {{type}}"
              type="text" pInputText autocomplete="new-password" />
            <!-- <div class="input-group-btn "> -->
            <button appNoDblClick id="{{ getFormControlName() }}btn" class="btn btn-outline-secondary integrado"
              type="button" (click)="clearFormControl()" title="{{ 'General.delete' | translate}}"
              [attr.disabled]="!isEditable() ? 'disabled' : null" [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'"
              tabindex="-1">
              <i class="pi pi-times"></i>
            </button>
            <button appNoDblClick class="btn btn-outline-secondary integrado" type="button" (click)="openDivisionTree()"
              title="{{ 'General.search.text' | translate}}" [attr.disabled]="!isEditable() ? 'disabled' : null"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" tabindex="{{ tabindex }}">
              <i class="pi pi-caret-down"></i>
            </button>
            <!-- </div> -->
          </div>
        </ng-container>
        <ng-container *ngIf="type == 'IMAGE'">
          <div class="d-inline-block" [ngClass]="fieldStyle">
            <img [attr.src]="getNestedProperty(model, jsonField)" />
            <i [attr.class]="getNestedProperty(model, jsonField)?'':'far fa-eye-slash fa-5x'"></i>
          </div>
        </ng-container>
        <ng-container *ngIf="type == 'TEMPLATE'">
          <ng-container *ngTemplateOutlet="template; context: { formPlycaGroup: this.formGroup }"></ng-container>
        </ng-container>
        <ng-container *ngIf="type == 'COMPANY'">
          <div class="p-inputgroup" id="{{ getFormControlName() }}ui">
            <input (focus)="showContextHelp()" (focusout)="setNestedPropertyLostFocus(model, jsonField)"
              *ngIf="!standaloneControl" id="{{ getFormControlName() }}" [formControlName]="getFormControlName()"
              [attr.type]="this.fieldConfig.typePassword?'password':'text'" name="{{ jsonField }}" placeholder=""
              [ngModel]="toString(getValue())" (input)="setNestedProperty(model, jsonField, $event.target.value)"
              pInputText class="plForm-element {{type}}" maxlength="{{ maxlength }}" [attr.disabled]="'disabled'"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" autocomplete="off"
              [attr.autofocus]="autofocus ? '' : null" />
            <input (focus)="showContextHelp()" (focusout)="setNestedPropertyLostFocus(model, jsonField)"
              *ngIf="standaloneControl" id="{{ getFormControlName() }}" name="{{ jsonField }}" type="text"
              placeholder="" [ngModel]="toString(getValue())"
              (input)="setNestedProperty(model, jsonField, $event.target.value)" pInputText
              class="plForm-element {{type}}" maxlength="{{ maxlength }}" [ngModelOptions]="{ standalone: true }"
              [attr.disabled]="'disabled'" [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" autocomplete="off"
              [attr.autofocus]="autofocus ? '' : null" />
            <button appNoDblClick *ngIf="isDeleteCompanyEnabled()" class="btn btn-outline-secondary integrado"
              type="button" (click)="clearFormControl()" title="{{ 'General.delete' | translate}}"
              [attr.disabled]="!isEditable() ? 'disabled' : null" [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'"
              tabindex="-1">
              <i class="pi pi-times"></i>
            </button>
            <button appNoDblClick *ngIf="isAddCompanyEnabled()" type="button" pButton pRipple icon="fas fa-plus"
              class="btn btn-outline-secondary integrado-multi t-action-button"
              (click)="openWindowCompany(jsonField,true)" tabindex="{{ tabindex }}"
              title="{{ 'General.add' | translate}}" [attr.disabled]="!isEditable() ? 'disabled' : null"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" tabindex="{{ tabindex }}"></button>
            <button appNoDblClick *ngIf="isEditCompanyEnabled()" type="button" pButton pRipple icon="fas fa-pen"
              class="btn btn-outline-secondary integrado-multi t-action-button"
              (click)="openWindowCompany(jsonField,false)" tabindex="{{ tabindex }}"
              title="{{ 'General.edit' | translate}}" [attr.disabled]="!isEditable() ? 'disabled' : null"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'" tabindex="{{ tabindex }}"></button>
            <button appNoDblClick *ngIf="isSearchCompanyEnabled()" type="button" pButton pRipple icon="fas fa-search"
              class="btn btn-outline-secondary integrado-multi t-action-button" (click)="openSearchGeneric()"
              tabindex="{{ tabindex }}" title="{{ 'General.search.text' | translate}}"
              [attr.disabled]="!isEditable() ? 'disabled' : null"
              [ngClass]="isEditable() ? 'EDITABLE' : 'NOEDITABLE'"></button>
          </div>
        </ng-container>
      </ng-container>
      <!-- FIN MODO EDICION -->
    </ng-container>
  </div>
</ng-container>
<ng-container *ngIf="type == 'HIDDEN' && this.abstractControl">
  <input type="hidden" inputId="{{ getFormControlName() }}" name="{{ jsonField }}" [ngModel]="getValue()">
</ng-container>
<ng-template #formDescription>
  <ng-container *ngIf="!inlineComponent">
    <label [attr.for]="getFormControlName()" id="{{ getFormControlName() + '_label' }}" [ngClass]="{
      'form-elements__label--check': type === formElementsTypes.CHECK,
      'form-elements__label--textarea': type === formElementsTypes.TEXTAREA,
      'form-elements__label--textarea-help': type === formElementsTypes.TEXTAREA && helpEntriesAvailable()
  }">{{ getDescription() }}<span *ngIf="isRequired()">*</span>
    </label>
    <i *ngIf="helpText" class="fa fa-info-circle text text-info m-l-sm" style="cursor:pointer;" aria-hidden="true"
      (click)="showHelp()" appNoDblClick></i>
    <i *ngIf="helpEntriesAvailable()" class="fa fa-info-circle text text-info m-l-sm" [ngClass]="{
      'form-elements__info': type !== formElementsTypes.TEXTAREA,
      'form-elements__info--textarea': type === formElementsTypes.TEXTAREA && helpEntriesAvailable()
  }" aria-hidden="true" (click)="showHelpEntries()"></i>
    <ng-container *ngTemplateOutlet="
              fieldErrors;
              context: { errors: this.abstractControl?.errors }
            "></ng-container>
    <span *ngIf="showFieldInfo()" (click)="fieldInfo.toggle($event)"><i class="pl-1 fas fa-tools text text-info"
        style="cursor:pointer;" aria-hidden="true"></i></span>
    <span class="overlabel"></span>
  </ng-container>
  <div #actualTarget></div>
</ng-template>
<ng-template #fieldErrors let-errorList="errors">
  <ng-container *ngIf="errorList && type !== 'TABLE'">
    <ng-container *ngIf="this.filterErrors([ERRORTYPE.EXCEPTION, ERRORTYPE.FATAL], errorList); let filteredErrors">
      <i (click)="fatal.toggle($event)" class="fas fa-exclamation-circle text-danger m-l-sm" [ngClass]="{
        'form-elements__info--textarea': type === formElementsTypes.TEXTAREA
    }" aria-hidden="true"></i>
      <p-overlayPanel #fatal [dismissable]="true" [showCloseIcon]="true" [appendTo]="'formElementLabel'">
        <formControlErrorMessage [errors]="filteredErrors"></formControlErrorMessage>
      </p-overlayPanel>
    </ng-container>
    <!-- <ng-container *ngIf="this.filterErrors(ERRORTYPE.FATAL, errorList); let filteredErrors">
              <i (click)="fatal.toggle($event)" class="fa fa-lg fa-exclamation-circle text-danger m-l-sm"
                aria-hidden="true"></i>
              <p-overlayPanel #fatal [dismissable]="true" [showCloseIcon]="true" [appendTo]="'formElementLabel'">
                <formControlErrorMessage [errors]="filteredErrors"></formControlErrorMessage>
              </p-overlayPanel>
            </ng-container>-->
    <ng-container *ngIf="this.filterErrors(ERRORTYPE.ERROR, errorList); let filteredErrors">
      <i (click)="error.toggle($event)" class="fas fa-exclamation-triangle text-danger m-l-sm" [ngClass]="{
        'form-elements__info--textarea': type === formElementsTypes.TEXTAREA
    }" aria-hidden="true" #errorIcon></i>
      <p-overlayPanel #error [dismissable]="true" [showCloseIcon]="true" [appendTo]="'formElementLabel'">
        <formControlErrorMessage [errors]="filteredErrors"></formControlErrorMessage>
      </p-overlayPanel>
    </ng-container>
    <ng-container *ngIf="
                this.filterErrors([ERRORTYPE.WARNING], errorList);
                let filteredErrors
              ">
      <i (click)="warn.toggle($event)" class="fas fa-exclamation-triangle text-warning m-l-sm" [ngClass]="{
        'form-elements__info--textarea': type === formElementsTypes.TEXTAREA
    }" aria-hidden="true" #warnIcon></i>
      <p-overlayPanel #warn [dismissable]="true" [showCloseIcon]="true" [appendTo]="'formElementLabel'">
        <formControlErrorMessage [errors]="filteredErrors"></formControlErrorMessage>
      </p-overlayPanel>
    </ng-container>
  </ng-container>
</ng-template>
<ng-template #fieldActionsTpl>
  <ng-container *ngIf="isEditable() && fieldActions && fieldActions.length > 0">
    <ng-container *ngFor="let action of fieldActions">
      <!-- <button (click)="execFunction (action)" [ngClass]="action.buttonClass"><span><i class=""
                    ></i></span></button> -->
      <button appNoDblClick type="button" class="btn btn-outline-secondary btn-sm add-button ml-2"
        *ngIf="isVisibleInputAction(action )" [attr.disabled]="!(isActiveInputAction(action )) ? 'disabled' : null"
        (click)="execFunction (action)" title="{{ action.buttonTextKey | translate }}" tabindex="{{ tabindex }}">
        <i class="p-button-icon-left ui-clickable" [ngClass]="action.imageClass" aria-hidden="true"></i><span
          class="p-button-text ui-clickable">{{ action.buttonTextKey | translate }}</span>
      </button>
    </ng-container>
  </ng-container>
</ng-template>
<ng-template #inputActions>
  <ng-container *ngIf="this.fieldConfig.inputActions && this.fieldConfig.inputActions.length > 0">
    <ng-container *ngFor="let action of this.fieldConfig.inputActions">
      <button appNoDblClick *ngIf="isVisibleInputAction(action )" type="button" pButton pRipple icon="fas fa-search"
        class="btn btn-outline-secondary integrado-multi t-action-button" (click)="executeRowAction(action,row)"
        [attr.disabled]="(isActiveInputAction(action )) ? null: 'disabled'" tabindex="{{ tabindex }}"
        title="{{ action.buttonTextKey | translate}}"
        [ngClass]="isActiveInputAction(action) ? 'EDITABLE' : 'NOEDITABLE'" tabindex="{{ tabindex }}"
        icon="{{action.imageClass}}"></button>
    </ng-container>
  </ng-container>
</ng-template>
<ng-template #editorToolbar>
  <span class="ql-formats">
    <button appNoDblClick class="ql-header" value="1" data-placement="bottom"
      title="{{ 'HtmlEditor.header' | translate}} 1" aria-label="{{ 'HtmlEditor.header' | translate}} 1"
      type="button"></button>
    <button appNoDblClick class="ql-header" value="2" data-placement="bottom"
      title="{{ 'HtmlEditor.header' | translate}} 2" aria-label="{{ 'HtmlEditor.header' | translate}} 2"
      type="button"></button>
    <select class="ql-size" data-placement="bottom" title="{{ 'HtmlEditor.size.description' | translate}}"
      aria-label="{{ 'HtmlEditor.size.description' | translate}}">
      <option value="huge">{{ 'HtmlEditor.size.huge' | translate}}</option>
      <option value="large">{{ 'HtmlEditor.size.large' | translate}}</option>
      <option selected>{{ 'HtmlEditor.size.normal' | translate}}</option>
      <option value="small">{{ 'HtmlEditor.size.small' | translate}}</option>
    </select>
  </span>
  <span class="ql-formats">
    <button appNoDblClick class="ql-bold" data-toggle="tooltip" data-placement="bottom"
      title="{{ 'HtmlEditor.bold' | translate}}" aria-label="{{ 'HtmlEditor.bold' | translate}}" type="button"></button>
    <button appNoDblClick class="ql-italic" data-placement="bottom" title="{{ 'HtmlEditor.italic' | translate}}"
      aria-label="{{ 'HtmlEditor.italic' | translate}}" type="button"></button>
    <button appNoDblClick class="ql-underline" data-placement="bottom" title="{{ 'HtmlEditor.underline' | translate}}"
      aria-label="{{ 'HtmlEditor.underline' | translate}}" type="button"></button>
    <button appNoDblClick class="ql-strike" data-placement="bottom" title="{{ 'HtmlEditor.strike' | translate}}"
      aria-label="{{ 'HtmlEditor.strike' | translate}}" type="button"></button>
    <select class="ql-color" data-placement="bottom" title="{{ 'HtmlEditor.color' | translate}}"
      aria-label="{{ 'HtmlEditor.color' | translate}}" type="button"></select>
    <select class="ql-background" data-placement="bottom" title="{{ 'HtmlEditor.background' | translate}}"
      aria-label="{{ 'HtmlEditor.background' | translate}}" type="button"></select>
    <button appNoDblClick class="ql-script" value="sub" data-placement="bottom"
      title="{{ 'HtmlEditor.sub-script' | translate}}" aria-label="{{ 'HtmlEditor.sub-script' | translate}}"
      type="button"></button>
    <button appNoDblClick class="ql-script" value="super" data-placement="bottom"
      title="{{ 'HtmlEditor.super-script' | translate}}" aria-label="{{ 'HtmlEditor.super-script' | translate}}"
      type="button"></button>
    <button appNoDblClick class="ql-code" data-placement="bottom" title="{{ 'HtmlEditor.code' | translate}}"
      aria-label="{{ 'HtmlEditor.code' | translate}}" type="button"></button>
  </span>
  <span class="ql-formats">
    <button appNoDblClick class="ql-list" value="ordered" data-placement="bottom"
      title="{{ 'HtmlEditor.ordered' | translate}}" aria-label="{{ 'HtmlEditor.ordered' | translate}}"
      type="button"></button>
    <button appNoDblClick class="ql-list" value="bullet" data-placement="bottom"
      title="{{ 'HtmlEditor.bullet' | translate}}" aria-label="{{ 'HtmlEditor.bullet' | translate}}"
      type="button"></button>
    <button appNoDblClick class="ql-indent" value="-1" data-placement="bottom"
      title="{{ 'HtmlEditor.indent-minus' | translate}}" aria-label="{{ 'HtmlEditor.indent-minus' | translate}}"
      type="button"></button>
    <button appNoDblClick class="ql-indent" value="+1" data-placement="bottom"
      title="{{ 'HtmlEditor.indent-add' | translate}}" aria-label="{{ 'HtmlEditor.indent-add' | translate}}"
      type="button"></button>
    <button appNoDblClick class="ql-blockquote" data-placement="bottom" title="{{ 'HtmlEditor.blockquote' | translate}}"
      aria-label="{{ 'HtmlEditor.blockquote' | translate}}" type="button"></button>
    <select class="ql-align" data-placement="bottom" title="{{ 'HtmlEditor.align' | translate}}"
      aria-label="{{ 'HtmlEditor.align' | translate}}">
      <option value=""></option>
      <option value="center"></option>
      <option value="right"></option>
      <option value="justify"></option>
    </select>
    <button appNoDblClick class="ql-code-block" data-placement="bottom" title="{{ 'HtmlEditor.code-block' | translate}}"
      aria-label="{{ 'HtmlEditor.code-block' | translate}}" type="button"></button>
  </span>
  <span class="ql-formats">
    <button appNoDblClick class="ql-image" data-placement="bottom" title="{{ 'HtmlEditor.image' | translate}}"
      aria-label="{{ 'HtmlEditor.image' | translate}}" type="button"></button>
    <button appNoDblClick class="ql-link" data-placement="bottom" title="{{ 'HtmlEditor.link' | translate}}"
      aria-label="{{ 'HtmlEditor.link' | translate}}" type="button"></button>
  </span>
  <span class="ql-formats">
    <button appNoDblClick class="ql-clean" data-placement="bottom" title="{{ 'HtmlEditor.clean' | translate}}"
      aria-label="{{ 'HtmlEditor.clean' | translate}}" type="button"></button>
  </span>
  <span class="ql-formats">
    <button appNoDblClick class="fa fa-expand" (click)="htmlEditorFullScreen()" data-placement="bottom"
      title="{{ 'HtmlEditor.fullscreen' | translate}}" aria-label="{{ 'HtmlEditor.fullscreen' | translate}}"
      type="button"></button>
  </span>
</ng-template>